import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/lib/constants";
import { useLanguage } from "@/lib/i18n";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function FloatingWhatsApp() {
  const { t } = useLanguage();

  return (
    <motion.a
      data-testid="whatsapp-floating-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.floating}
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="whatsapp-pulse fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 group flex items-center gap-0 sm:hover:gap-3 rounded-full bg-whatsapp text-white p-4 shadow-2xl shadow-whatsapp/40 transition-all duration-300"
    >
      <WhatsAppIcon className="w-6 h-6" />
      <span className="max-w-0 sm:group-hover:max-w-[180px] overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-500">
        {t.floating}
      </span>
    </motion.a>
  );
}
